import { React } from 'react';
import { Link,  useNavigate } from "react-router-dom";

export default function Footer({ currentPath, scrollToElement }) {
    const navigate = useNavigate();
    
    const handleClick = (id) => {
        if (currentPath !== '/') {
          // Если мы не на главной странице, переходим на главную
          navigate('/');
        }
        // Прокручиваем к нужному элементу
        scrollToElement(id);
      };
    
    return (
        <section className="footer-section flex">
            <div className="footer-container container">
                <ul className="footer-list list-reset flex">
                    <li className="footer-list-item">
                        <h3 className="item-title">
                            Экосистема Медгуру
                        </h3>
                        <ul className="item-list flex list-reset">
                            <li className="item-points">
                                <a href="#1" onClick={() => handleClick('1')} style={{cursor: "pointer"}}>
                                    MedGuru — полноценная двусторонняя 
                                    коммуникация
                                </a>
                            </li>
                            <li className="item-points">
                                <a href="#2" onClick={() => handleClick('2')} style={{cursor: "pointer"}}>
                                    Области нашей экпертизы
                                </a>
                            </li>
                            <li className="item-points">
                                <a href="#3" onClick={() => handleClick('3')} style={{cursor: "pointer"}}>
                                    Партнеры
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li className="footer-list-item">
                        <h3 className="item-title">
                            Наши продукты
                        </h3>
                        <ul className="item-list flex list-reset">
                            <li className="item-points">
                                <Link to="/omnichannel">
                                    Омниканальные маркетинговые проекты                                
                                </Link>
                            </li>
                            <li className="item-points">
                                <Link to="/crm">
                                    CRM-система Oragen
                                </Link>
                            </li>
                            <li className="item-points">
                                <Link to="/production">
                                    Продакшн
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className="footer-list-item">
                        <h3 className="item-title">
                            Связаться с нами
                        </h3>
                        <ul className="item-list flex list-reset">
                            <li className="item-points">
                                Ведущий менеджер по развитию бизнеса<br/>
                                <a href="tel:+79995006454">
                                    +7 929 662 35 61
                                </a>
                            </li>
                            <li className="item-points">
                                Руководитель ИТ-отдела<br/>
                                <a href="tel:+79998699276">
                                    +7 999 869-92-76  
                                </a>
                            </li>
                            <li className="item-points">
                                <a href="mailto:manager@medguru.studio">
                                    manager@medguru.studio
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>

                {/* <ul className="footer-info-list list-reset flex">
                    <li className="info-list-item">
                        &copy;&nbsp;ООО &laquo;МедГуру&raquo;, 2025. Все права сохранены за&nbsp;правообладателем.<br/>
                        &copy; &quot; MedGuru&quot;, LLC, 2025. All rights reserved.
                    </li>
                    <li className="info-list-item">
                        ИНН 7716860313
                    </li>
                    <li className="info-list-item">
                        КПП 773401001
                    </li>
                    <li className="info-list-item" style={{cursor: "pointer"}}>
                        ОГРН 1177746556130
                    </li>
                </ul>
                <ul className="footer-info-list-add list-reset flex">
                    <li className="info-list-item" style={{cursor: "pointer"}}>
                        Адрес: 123060, г. Москва, ул. Маршала Рыбалко, <br/>дом 2, корпус 6, помещение I, комната 5, офис 722
                    </li>

                    <li className="info-list-item" style={{cursor: "pointer"}}>
                        +7 495 445-45-10 <br/>
                        mail@medguru.studio
                    </li>
                </ul>

                <ul className="footer-info-list-add list-reset flex" style={{justifyContent: 'flex-start', paddingBottom: "63px"}}>
                    <li className="info-list-item" style={{width: "29vw", marginRight: "40px"}}>
                        Основной код ОКВЭД: 62.02 (деятельность консультативная и работы в области компьютерных технологий)
                    </li>

                    <li className="info-list-item" style={{width: "29vw"}}>
                        Виды ИТ-деятельности согласно приказу Минцифры № 449 от 11.05.2023 г.: 1.01, 2.01, 16.01
                    </li>
                </ul>

                <ul className="footer-info-list-add list-reset flex" style={{justifyContent: 'flex-start', paddingBottom: "63px"}}>
                    <li className="info-list-item" style={{ width: "29vw", marginRight: "40px" }}>
                        Политика обработки персональных данных{" "}
                        <a
                            href="https://privacy.medtouch.org"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: "underline", color: "inherit" }}
                        >
                            privacy.medtouch.org
                        </a>
                    </li>

                    <li className="info-list-item" style={{}}>
                        Персональные данные физических лиц размещены на&nbsp;сайте с&nbsp;их&nbsp;согласия на&nbsp;обработку персональных данных, разрешенных для распространения, с&nbsp;целью продвижения товаров, работ, услуг на&nbsp;рынке. Отдельные условия и&nbsp;запреты физическими лицами&nbsp;&mdash; субъектами персональных данных не&nbsp;установлены.
                    </li>
                </ul> */}

                <div className="footer-container-btm" style={{ fontSize: "12px" }}>
                    <div className="footer-columns">
                        {/* ЛЕВАЯ КОЛОНКА */}
                        <div className="footer-left">
                            <ul className="footer-info list-reset">
                            <li className="info-item">
                                &copy;&nbsp;ООО &laquo;МедГуру&raquo;, 2025. Все права сохранены за&nbsp;правообладателем.<br/>
                                &copy; "MedGuru", LLC, 2025. All rights reserved.
                            </li>
                            <li className="info-item">ИНН 7716860313</li>
                            <li className="info-item">КПП 773401001</li>
                            <li className="info-item">ОГРН 1177746556130</li>
                            </ul>

                            <ul className="footer-info list-reset">
                            <li className="info-item">
                                Адрес: 123060, г. Москва, ул. Маршала Рыбалко,<br/>
                                дом 2, корпус 6, помещение I, комната 5, офис 722
                            </li>
                            <li className="info-item">
                                +7 495 445-45-10<br/>
                                mail@medguru.studio
                            </li>
                            </ul>
                        </div>

                        {/* ПРАВАЯ КОЛОНКА */}
                        <div className="footer-right">
                            <ul className="footer-info list-reset">
                            <li className="info-item">
                                Основной код ОКВЭД: 62.02 (деятельность консультативная и работы в области компьютерных технологий)
                            </li>
                            <li className="info-item">
                                Виды ИТ-деятельности согласно приказу Минцифры № 449 от 11.05.2023 г.: 1.01, 2.01, 16.01
                            </li>
                            </ul>

                            <ul className="footer-info list-reset">
                            <li className="info-item">
                                Политика обработки персональных данных{" "}
                                <a
                                href="https://privacy.medtouch.org"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="footer-link"
                                >
                                privacy.medtouch.org
                                </a>
                            </li>
                            <li className="info-item">
                                Персональные данные физических лиц размещены на сайте с их согласия на обработку персональных данных, разрешенных для распространения, с целью продвижения товаров, работ, услуг на рынке. Отдельные условия и запреты физическими лицами - субъектами персональных данных не установлены.
                            </li>
                            </ul>
                        </div>
                    </div>
                    <p className="footer-wide-text" style={{ fontSize: "12px" }}>
                        ООО &laquo;МедГуру&raquo; осуществляет деятельность по&nbsp;разработке, сопровождению программ для ЭВМ (код 1.01 согласно приказу Минцифры &#8470;&nbsp;449 от&nbsp;11.05.2023&nbsp;г.), их&nbsp;реализации (код 2.01), а&nbsp;также по&nbsp;предоставлению доступа к&nbsp;электронной образовательной&nbsp;и (или) просветительской информации с&nbsp;использованием собственной программы для ЭВМ (код 16.01).
                        Стоимость использования программного обеспечения рассчитывается индивидуально по&nbsp;запросу на&nbsp;электронную почту sales@medguru.studio. Способ распространения программного обеспечения: интернет&nbsp;&mdash; Интернет-сервис (SaaS). 
                        Доступ к&nbsp;программе для ЭВМ &laquo;Образовательная медицинская платформа Medtouch&nbsp;2.0&raquo; посредством сети &laquo;Интернет&raquo; для использования ее&nbsp;по&nbsp;функциональному назначению (прослушивание мероприятий, ознакомление с&nbsp;размещенным контентом) осуществляется безвозмездно для зарегистрированных пользователей. За&nbsp;размещение контента или проведение с&nbsp;использованием программы для ЭВМ мероприятий иными лицами, за&nbsp;исключением ООО &laquo;МедГуру&raquo;, может взиматься плата.
                    </p>
                </div>
            </div>
        </section>
  )
}
